<template>
  <section class="section">
    <h2>How It Works</h2>
    <ol class="steps">
      <li>Create tournament</li>
      <li>Add teams or allow teams to register</li>
      <li>Generate fixtures</li>
      <li>Update results</li>
    </ol>

    <div class="poster-card">
      <img :src="posterImage" alt="Tournament poster shared to invite fans" loading="lazy" />
      <p>Publish your poster to the fanbase so the IPA community can cheer their teams.</p>
    </div>
  </section>
</template>

<script setup>
import posterImage from "@/assets/images/tournament/poster.png";
</script>

<style scoped>
.section {
  padding: 1.6rem 0 0.75rem;
}

h2 {
  margin: 0 0 0.8rem;
  font-size: 1.45rem;
  color: var(--text-color1);
  font-weight: 800;
}

.steps {
  margin: 0 0 1rem;
  padding-left: 1.2rem;
  color: var(--text-color1);
  opacity: 0.9;
}

.steps li + li {
  margin-top: 0.45rem;
}

.poster-card {
  border: 1px dashed var(--border-color-hover1, #e5e7eb);
  border-radius: 16px;
  padding: 0.75rem;
  background: var(--background-color1, #f9fafb);
}

.poster-card img {
  width: 100%;
  border-radius: 12px;
  margin-bottom: 0.6rem;
}

.poster-card p {
  margin: 0;
  color: var(--text-color1);
  opacity: 0.88;
}
</style>
